import React from 'react'
import { withAppContextDecorators } from '@/common/AppContext';
import { Breadcrumb } from 'antd';
import './index.less'
import {useHistory} from "react-router-dom";
const EnterpriseQualification = (props) => {
    const history = useHistory()

    const contentList = [
        {
            text: [
                "国诚投顾全称为深圳市国诚投资咨询有限公司，成立于2004年6月，获颁中华人民共和国经营证券期货业务许可证。流水号：000000028987，是经中国证监会批准成立的持牌证券投资咨询机构。"
            ]
        },
    ]

    return <div id="enterpriseQualification">
        <div className={'breadcrumb-con warp'}>
            <Breadcrumb separator=">">
                <Breadcrumb.Item onClick={()=>{history.push({pathname:'/index'})}}>首页</Breadcrumb.Item>
                <Breadcrumb.Item>企业资质</Breadcrumb.Item>
            </Breadcrumb>
        </div>

        <div className={'centerBox warp'}>
            <div className={'module-title'}>
                <h2>股海波浪 国诚守航</h2>
            </div>
        </div>

        <div className={'content-intro warp'}>
            <div className={'intro-list'}>
                {
                    contentList.map(item=>{
                        return   <div className={'intro-item'}>
                            <div className={'intro-describe'}>
                                {item.text}
                            </div>
                        </div>
                    })
                }
            </div>
            <div className={'img'}>
                <img src={require(`@/assets/images/compliance/img1.png`)} />
                <img src={require(`@/assets/images/compliance/img2.png`)} />
                <img src={require(`@/assets/images/compliance/img3.png`)} />
            </div>
        </div>


    </div>
}
export default withAppContextDecorators(EnterpriseQualification)
